'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname, useSearchParams } from 'next/navigation';
import { usePostHog } from 'posthog-js/react';
import { Suspense, useEffect } from 'react';
import { useIdleCallback } from '@/hooks/use-idle-callback';
import { useInstallationStore } from '@/lib/stores/installation-store';
import { useAuth } from '@/providers/auth-provider';
function PostHogPageView() {
  const $ = _c(14);
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const posthog = usePostHog();
  const {
    user,
    isAuthenticated
  } = useAuth();
  const {
    selectedInstallationId
  } = useInstallationStore();
  let t0;
  let t1;
  if ($[0] !== pathname || $[1] !== posthog || $[2] !== searchParams) {
    t0 = () => {
      if (pathname && posthog) {
        let url = window.origin + pathname;
        if (searchParams.toString()) {
          url = `${url}?${searchParams.toString()}`;
        }
        posthog.capture("$pageview", {
          $current_url: url
        });
      }
    };
    t1 = [pathname, searchParams, posthog];
    $[0] = pathname;
    $[1] = posthog;
    $[2] = searchParams;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[5] !== isAuthenticated || $[6] !== posthog || $[7] !== user) {
    t2 = () => {
      if (user && isAuthenticated && !posthog._isIdentified()) {
        posthog.identify(user.id, {
          email: user.email,
          username: user.user_metadata.username,
          name: user.user_metadata.name,
          avatar: user.user_metadata.avatar,
          github_username: user.user_metadata.github_username,
          github_id: user.user_metadata.github_id,
          role: user.role,
          is_anonymous: user.is_anonymous,
          last_sign_in_at: user.last_sign_in_at,
          created_at: user.created_at,
          updated_at: user.updated_at
        });
      }
    };
    t3 = [posthog, user, isAuthenticated];
    $[5] = isAuthenticated;
    $[6] = posthog;
    $[7] = user;
    $[8] = t2;
    $[9] = t3;
  } else {
    t2 = $[8];
    t3 = $[9];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[10] !== posthog || $[11] !== selectedInstallationId) {
    t4 = () => {
      if (!selectedInstallationId || !posthog) {
        return;
      }
      posthog.group("installation", selectedInstallationId.toString());
    };
    t5 = [posthog, selectedInstallationId];
    $[10] = posthog;
    $[11] = selectedInstallationId;
    $[12] = t4;
    $[13] = t5;
  } else {
    t4 = $[12];
    t5 = $[13];
  }
  useIdleCallback(t4, t5);
  return null;
}

// Wrap this in Suspense to avoid the `useSearchParams` usage above
// from deopting the whole app into client-side rendering
// See https://nextjs.org/docs/messages/deopted-into-client-rendering
export default function SuspendedPostHogPageView() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Suspense fallback={null}><PostHogPageView /></Suspense>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}